import styled from "styled-components";
import { mainColor } from "../styles/colors";
export const Tabs = styled.div`
  display: flex;
  margin-left: -20px;
  margin-right: -20px;
  border-bottom: 1px solid var(--app-border);
  padding-left: 20px;
  gap: 4px;
`;

export const tabStyles = `
	padding: 12px 18px;
	margin-right: 4px;
	color: var(--app-muted);
	position: relative;
	transition: color 200ms ease-in;
	cursor: pointer;
  font-weight: 700;

&:hover {
  color: ${mainColor};
}

&.active {
  color: ${mainColor};
}

&.active:after {
	  position: absolute;
	  content: "";
	  width: 100%;
	  height: 3px;
	  background-color: ${mainColor};
	  bottom: -2px;
	  left: 0;
    border-radius: 3px 3px 0 0;
	}`;

export const Tab = styled.div`
  ${tabStyles}
`;
